<template>
  <section v-if="allWatchLists && allWatchLists[0].resources">
    <h2 class="mx-6 md:mx-8 lg:w-[750px] lg:mx-auto mt-6 mb-[16px]">
      {{ allWatchLists[0].name }}
    </h2>
    <div class="xs:mx-6 md:mx-8 lg:w-[750px] rounded-3xl lg:mx-auto mt-4 mb-6 space-y-8">
      <ResourceCard
        v-for="item in allWatchLists[0].resources"
        :key="`${item.slug}-${item.type}`"
        :image-url="item.thumbnail"
        :title="item.title"
        :slug="item.slug"
        :type="item.type"
        :tag-slug="tagSlug"
        :duration="item.duration"
        :is-exclusive="item.isCVPExclusive"
        :is-audio="item.isAudio"
        :avail-translations="item.availTranslations"
        :resource-translations="item.resourceTranslations"
        :videoProgess="item.videoProgess"
        :videoTime="item.videoTime"
        :preacher="item.preacher"
      />
    </div>
  </section>
</template>

<script>
import ResourceCard from '@/components/HomePage/MustwatchSection/ResourceCard.vue';
export default {
  components: {
    ResourceCard,
  },
  props: {
    allWatchLists: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
h2 {
  @apply text-[32px] leading-[48px] font-aktiv-grotesk-medium text-blue;
}
</style>
